<template>
  <div class="base-rounded-radiobutton" :id="id" :class="{ 'checked': checked }" data-test="radioButtonBase" @click.stop.prevent="doCheck"></div>
</template>

<style scoped lang="scss">
.base-rounded-radiobutton {
  @include                      border_radius(50%);
  display:                      flex;
  justify-content:              center;
  align-items:                  center;
  width:                        25px;
  height:                       25px;
  margin-right:                 10px;
  // background:                   #D8D8D8;
  border:                       1px solid var(--Shades-30);
  cursor:                       pointer;

  &:before {
    @include                    border_radius(50%);
    content:                    '';
    width:                      15px;
    height:                     15px;
    background-color:           transparent;
    transition:                 background-color 0.2s ease-in-out;
  }

  &.checked {
    background-color:           #3CB391;
    border-color:               #3CB391;

    &:before {
      background-color:         #FFFFFF;
    }
  }
}
</style>

<script>
export default {
  name: 'BaseRadioButton',
  props: {
    id: String,
    item: [String, Object],
    checked: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    doCheck() {
      // O radio button deve emitir o evento de 'checked' para o componente pai
      // O pai é responsável por gerenciar qual radio button está selecionado
      this.$emit('checked', this.item);
    }
  }
}
</script>
